import PropTypes from 'prop-types'
import { useEffect } from 'react'
import authProvider from '../../core/AuthenticationProvider'
import MessageHub from '../../core/signalr/SignalrMessageHub'

const data = {}
const timeout = {}
const timeoutAction = 1000

export const Realtime = ({ children, channel, action, stackName }) => {
  useEffect(() => {
    if (stackName) {
      data[stackName] = []
      timeout[stackName] = null
    }
    return () => {
      if (stackName) {
        delete data[stackName]
        delete timeout[stackName]
      }
    }
  }, [])

  useEffect(() => {
    const dispatchAction = (message) => {
      if (stackName) {
        if (timeout[stackName]) {
          clearTimeout(timeout[stackName])
        }
        data[stackName] = data[stackName]?.concat(message)
        timeout[stackName] = setTimeout(() => {
          action(data[stackName])
          data[stackName] = []
        }, timeoutAction)
      } else {
        action(message)
      }
    }

    authProvider.getUser().then((user) => {
      MessageHub.subscribe(
        [user.profile.user_id, channel].join('.'),
        dispatchAction,
      )
    })

    return () => {
      authProvider.getUser().then((user) => {
        MessageHub.unsubscribe(
          [user.profile.user_id, channel].join('.'),
          dispatchAction,
        )
      })
    }
  }, [channel])

  return <>{children}</>
}

Realtime.propTypes = {
  children: PropTypes.node.isRequired,
  channel: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  stackName: PropTypes.string,
}
